module.exports = __webpack_public_path__ + "95ed8d08f4511668e391ac880b001cf0.jpg";